import { Result } from "@kv-design/kui";
export var WechatAppAuthScope;
(function (WechatAppAuthScope) {
    WechatAppAuthScope["USER_INFO"] = "userInfo";
    // USER_LOCATION = "userLocation",//	地理位置
    // ADDRESS = "address",//通讯地址
    // INVOICE_TITLE = "invoiceTitle",//发票抬头
    // INVOICE = "invoice",//	获取发票
    // WERUN = "werun",//微信运动步数
    // RECORD = "record",//	录音功能
    // WRITE_PHOTOS_ALBUM = "writePhotosAlbum",//	保存到相册
    // CAMERA = "camera"//<camera /> 组件
})(WechatAppAuthScope || (WechatAppAuthScope = {}));
export default class WechatAppAuth {
    constructor(config) {
        this.getUserInfo = () => {
            return new Promise((resolve, reject) => {
                this.assertAuth(WechatAppAuthScope.USER_INFO).then(auth => {
                    if (!auth) {
                        reject("[MultiEnd] User hasn't authorize！ ");
                    }
                    wx.checkSession({
                        success: () => {
                            this.login(resolve, reject);
                        },
                        fail: () => {
                            this.authorize();
                        },
                    });
                });
            });
        };
        this.getRouter = () => {
            const pages = getCurrentPages();
            if (pages.length === 0) {
                throw new Error("[MultiEnd] getRouter => Page num is zero");
            }
            const page = pages[pages.length - 1];
            return {
                path: `/${page.route}`,
                query: page.options,
            };
        };
        this.setStorageSync = (key, value) => {
            wx.setStorageSync(key, JSON.stringify(value || {}));
        };
        this.getStorageSync = (key) => {
            const value = wx.getStorageSync(key);
            return !value ? value : JSON.parse(value);
        };
        this.clearStorageSync = () => {
            wx.clearStorageSync();
        };
        this.assertAuth = (scope) => {
            return new Promise((resolve, reject) => {
                wx.getSetting({
                    success: res => resolve(res.authSetting[`scope.${scope}`]),
                    fail: reject,
                });
            });
        };
        this.login = (resolve, reject) => {
            const { userProvider } = this._config;
            if (typeof userProvider === "function") {
                userProvider().then(userInfo => {
                    resolve(userInfo);
                }, reject);
            }
            else {
                const userInfo = this.getStorageSync("StorageKeys.STORAGE_USER_KEY");
                resolve(userInfo);
            }
        };
        this.authorize = async () => {
            return Result.success({
                message: "",
            });
            // return new Promise((resolve, reject) => {
            //     const {authorizeProvider} = this._config;
            //     wx.login({
            //         success: res => {
            //             const code = res.code;
            //             wx.getUserInfo({
            //                 withCredentials: true,
            //                 success: (res: WxUserResponse | any) => {
            //                     const {encryptedData, iv} = res;
            //                     authorizeProvider({
            //                         code: code,
            //                         encryptedData: encryptedData,
            //                         iv: iv,
            //                     }).then((userInfo: UserInfo) => {
            //                         this.setStorageSync("StorageKeys.STORAGE_USER_KEY", userInfo);
            //                         resolve(userInfo);
            //                     }, reject)
            //                 }
            //             });
            //
            //         },
            //         fail: reject,
            //     })
            // })
        };
        this._config = Object.assign({}, WechatAppAuth.DefaultConfig, config);
    }
}
WechatAppAuth.DefaultConfig = {
    withCredentials: true,
};
WechatAppAuth.create = (config) => {
    return new WechatAppAuth(config);
};
